export const mapStatusToKey = (status: string | null | undefined): 'inProgress' | 'completed' | 'notStarted' | 'notMet' | 'exceeded' => {
  if (!status) return 'notStarted';
  switch (status.toLowerCase()) {
    case 'partially_met':
    case 'partial':
    case 'in progress':
    case 'partially met':
      return 'inProgress';
    case 'complete':
    case 'completed':
    case 'met':
      return 'completed';
    case 'not started':
      return 'notStarted';
    case 'not met':
    case 'not_met':
    case 'overdue':
      return 'notMet';
    case 'exceeded':
      return 'exceeded';
    default:
      return 'notStarted';
  }
};
